// Copyright (c) 2022 by Move Closer

import { Identifier, ImageData, Module, ModuleContent, ProductData, Related } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export type UsageCalculatorModule = Module<UsageCalculatorModuleContent, AvailableModuleDriver.UsageCalculator>

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface UsageCalculatorContentData {
  isPreview: boolean
  image: ImageData | null
  products: UsageCalculatorProductData | null
  redirect: string | null
  siteId?: Identifier | null
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export type UsageCalculatorModuleContent = UsageCalculatorContentData & ModuleContent

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface UsageCalculatorModuleContentInput extends Omit<UsageCalculatorContentData, 'image' | 'products' | 'redirect'> {
  image?: Related | null
  products: UnresolvedUsageCalculatorProductData[]
  redirect: string | null
  siteId?: Identifier | null
}

export enum UsageCalculatorProduct {
  WinsFlexStrefaZewnetrznaWiadro = 'WinsFlexStrefaZewnetrznaWiadro',
  WinsFlexStrefaZewnetrznaKielbasa = 'WinsFlexStrefaZewnetrznaKielbasa',
  WinsFlexStrefaIzolacji = 'WinsFlexStrefaIzolacji',
  WinsFlexStrefaWewnetrznaWiadro = 'WinsFlexStrefaWewnetrznaWiadro',
  WinsFlexStrefaWewnetrznaKielbasa = 'WinsFlexStrefaWewnetrznaKielbasa',
  WinsFixStrefaZewnetrzna37 = 'WinsFixStrefaZewnetrzna37',
  WinsFixStrefaZewnetrzna712 = 'WinsFixStrefaZewnetrzna712',
  WinsFixStrefaZewnetrzna1018 = 'WinsFixStrefaZewnetrzna1018',
  WinsFixStrefaIzolacji = 'WinsFixStrefaIzolacji',
  WinsFixStrefaWewnetrznaWiadro = 'WinsFixStrefaWewnetrznaWiadro',
  WinsFixStrefaWewnetrznaKielbasa = 'WinsFixStrefaWewnetrznaKielbasa'
}

export type UsageCalculatorProductData = Record<UsageCalculatorProduct, ProductData | null>

export interface UnresolvedUsageCalculatorProductData {
  key: UsageCalculatorProduct
  related: Related | null
}

export type UsageCalculatorProductResult = Record<UsageCalculatorProduct, number>

export type UsageCalculatorProductSelection = Record<string, number>

export interface UsageCalculatorTotalResult {
  bands: number
  outside: number
  inside: number
  insulation: number
}

export interface UsageCalculatorResult {
  total: UsageCalculatorTotalResult
  productUsage: UsageCalculatorProductResult
}

export interface UsageCalculatorProductPrice {
  brutto: number
  netto: number
}

export enum UsageCalculatorTab {
  Fix = 'fix',
  Flex = 'flex'
}
